import React from 'react';
import Profile from '../container/Profile/Profile';

const layout=()=>{
    return(
        <Profile />
    )
}

export default layout;